export enum RentalVehicleFormTabs {
  BasicInformation = 'basic-information',
  VehicleData = 'vehicle-data',
  Features = 'features',
  ServiceIntervals = 'service-intervals',
  RentalInformation = 'rental-information',
}
